var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack397({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1.5,
    y: 1.5,
    width: 13,
    height: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.58,11.16V6.23H4.08V5.57H7.71v.66H6.19v4.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.63,11.16,7.85,5.57h.66L9.7,9.63c.09.32.17.62.24.91.07-.3.15-.61.25-.91l1.23-4.06H12l-1.79,5.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack397);
export default __webpack_public_path__ + "static/media/Symbol_pack_397.9208d0d9eafb930e5e45ed79f0e27909.svg";
export { ForwardRef as ReactComponent };